import "./consumptionChart.css";
import Header from "./subComponents/header";
import Footer from "./subComponents/footer";
import Patterns from "./subComponents/patterns";
import { useSelector } from "react-redux";
import { kiloToMegaWatt } from "./projectOverview";
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Filler,
  BarElement,
  Legend
);

function tableRender(tableData) {
  return (
    <div className="render-function">
      <table className="render-table">
        <thead>
          <tr>
            <td>Property</td>
            <td>Value</td>
          </tr>
        </thead>
        <tbody>
          {tableData.map((item, index) => {
            return (
              <tr key={index} className={index % 2 === 0 ? "one" : "two"}>
                <td className="left">{item.title}</td>
                <td className="right">{item.value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

function chartBallText(data) {
  return (
    <>
      {data.map((item, index) => {
        return (
          <div key={index} className="chart-ball-text">
            <div
              className="ball"
              style={{
                backgroundColor: item.backgroundColor,
                height: "15px",
                width: "15px",
                borderRadius: "50%",
              }}
            ></div>
            <p>{item.label}</p>
          </div>
        );
      })}
    </>
  );
}

const ConsumptionChart = (props) => {
  const { tableContent } = props;
  const pageDetail = tableContent.find(
    (item) => item.title === "Building Consumption Analysis"
  );
  const roofInfo = useSelector((state) => state.roof);
  const tcyValue = roofInfo?.value?.financialAnalysis?.tcy
    ? roofInfo.value.financialAnalysis.tcy
    : 0;
  const monthsConsumption = [
    roofInfo.value.financialAnalysis.jan,
    roofInfo.value.financialAnalysis.feb,
    roofInfo.value.financialAnalysis.mar,
    roofInfo.value.financialAnalysis.apr,
    roofInfo.value.financialAnalysis.may,
    roofInfo.value.financialAnalysis.jun,
    roofInfo.value.financialAnalysis.jul,
    roofInfo.value.financialAnalysis.aug,
    roofInfo.value.financialAnalysis.sep,
    roofInfo.value.financialAnalysis.oct,
    roofInfo.value.financialAnalysis.nov,
    roofInfo.value.financialAnalysis.dec,
  ];

  const maxMonthlyConsumption = Math.max(...monthsConsumption);

  let consumptionChart = [
    {
      title: "Total yearly consumption",
      value: `${kiloToMegaWatt(Number(tcyValue))}`,
    },
    {
      title: "Maximum monthly consumption",
      value: `${kiloToMegaWatt(Number(maxMonthlyConsumption))}`,
    },
  ];

  let options = {
    responsive: false,

    plugins: {
      tooltip: {
        enabled: false, // <-- this option disables tooltips
      },
      legend: {
        display: false, // Hide the legend
      },
    },
    scales: {
      x: {
        ticks: { color: "#929292", font: { size: 10 }, padding: 5 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Month", // X-axis title
        },
        grid: {
          display: false, // Extended vertical lines below x-axis only
          drawBorder: false,
        },
      },
      y: {
        ticks: { color: "#929292", font: { size: 10 }, padding: 10 },
        beginAtZero: true,
        title: {
          color: "#000",
          font: {
            size: 10,
          },
          display: true,
          text: "Energy in kWh", // Y-axis title
        },
        grid: {
          drawBorder: false, // <-- this removes y-axis line
        },
      },
    },
  };

  let state = {
    data: {
      labels: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      datasets: [
        {
          label: "Consumption",
          backgroundColor: "#045097",
          borderColor: "#045097",
          borderWidth: 1,
          data: monthsConsumption,
          borderRadius: 10, // Round the top edges of bars
          barThickness: 8,
        },
      ],
    },
  };

  return (
    <div id="consumption-chart" className="consumption-chart">
      {/* Patterns */}
      <Patterns />
      {/* Header */}
      <Header />
      {/* Main Body */}
      <main className="cc-body">
        <p>Building Consumption Chart</p>
        <div className="data-tables">
          {/* PV Panel */}
          {tableRender(consumptionChart)}
        </div>

        <p style={{ marginTop: "30px", marginBottom: "20px" }}>Chart</p>
        <Bar height="340px" width="495px" options={options} data={state.data} />
        <div className="chart-ball-text-container">
          {chartBallText(state.data.datasets)}
        </div>
      </main>

      {/* Footer */}
      <Footer
        pageNo={`${pageDetail ? pageDetail.pageNo : 12}/${
          tableContent[tableContent.length - 1].pageNo
        }`}
      />
    </div>
  );
};

export default ConsumptionChart;
